module.exports = __webpack_public_path__ + "6c98629280f3d79706617c4bf98437df.svg";